import EventSelectedInfo from '@/features/edit-event-strip';
import { KEY_RECOIL } from '@/shared/config';
import AfibButtonTypes from './afibButtonTypes';
import AfibStripEvents from './afibStripEvents';
import AfibEcgViewerWrapper from './afibEcgViewerWrapper';
import AfibHrChart from './afibHrChart';
import AfibHrChartOptions from './afibHrChartOptions';
import useAfibEvents from './useAfibEvents';

type AfibEventsProps = {
  activeButton?: any;
  isEmptyData?: boolean;
};

/**
 * Assembles the AFib events view from its toolbar, strip grid, event detail, ECG viewer and heart rate chart. Pulls study and report context from the hook, replaces the detail, viewer and chart with a no-data-recorded message when the tab is empty, and always renders the date navigator at the bottom.
 *
 * @param props - The tab props, supplying the active event sub-tab and the isEmptyData flag.
 * @returns The rendered AFib events tab with its toolbar, strips, viewer and chart.
 */
const AfibEvents = ({ activeButton, isEmptyData }: AfibEventsProps) => {
  const {
    profileId,
    studyId,
    startReport,
    stopReport,
    timezoneOffset,
    ecgDataMap,
    hrChartRef,
    handleClickArrowButton,
  } = useAfibEvents();

  return (
    <div className="beat-type-strip-content">
      <AfibButtonTypes />
      <AfibStripEvents
        activeButton={activeButton}
        ecgDataMap={ecgDataMap}
        profileId={profileId}
        studyId={studyId}
        timezoneOffset={timezoneOffset}
        startReport={startReport}
      />
      <div className="beat-type-strip-content-container">
        {isEmptyData ? (
          <div className="empty-data-container">
            <div className="empty-data-text">There is no data recorded</div>
          </div>
        ) : (
          <>
            <div className="event-select-ecg-viewer-wrapper --min-width-strip-event">
              <EventSelectedInfo
                keyRecoil={KEY_RECOIL.BEAT_HR}
                componentId="afib-event-selected-info"
                timezoneOffset={timezoneOffset}
                ecgDataMap={ecgDataMap}
              />
              <AfibEcgViewerWrapper
                ecgDataMap={ecgDataMap}
                profileId={profileId}
                studyId={studyId}
                timezoneOffset={timezoneOffset}
                handleClickArrowButton={handleClickArrowButton}
              />
            </div>
            <AfibHrChart
              ref={hrChartRef}
              ecgDataMap={ecgDataMap}
              timezoneOffset={timezoneOffset}
              studyId={studyId}
              profileId={profileId}
            />
          </>
        )}
        <AfibHrChartOptions
          profileId={profileId}
          timezoneOffset={timezoneOffset}
          studyId={studyId}
          startReport={startReport}
          stopReport={stopReport}
        />
      </div>
    </div>
  );
};

export default AfibEvents;
